/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 2a84f278b6b5
 */

import * as z from "zod";

export type CreateRequest = {
  transformation: string;
  allowed_for_strict?: boolean | undefined;
};

export const CreateRequest$zodSchema: z.ZodType<CreateRequest> = z.object({
  allowed_for_strict: z.boolean().optional().describe(
    "Whether to allow this named transformation when strict transformations are enabled. Strict transformations prevent transformations from being dynamically applied to media assets.\n",
  ),
  transformation: z.string().describe("A valid transformation string."),
});
